import React, { Suspense } from "react";
import Loading from "../Loading/Loading";

const VMSuspense = ({ children }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

export default VMSuspense;
